const createComponent = (tagName, properties = {}) => {
	const isObject = typeof properties === 'object' && !Array.isArray(properties);

	if (!isObject) {
		throw Error(`Properties should be an Object (${properties})`);
	}

	const component = document.createElement(tagName);

	for (const [property, value] of Object.entries(properties)) {
		component.setAttribute(property, value);
	}

	return component;
};

export default createComponent;
